import { useState, useRef, useEffect } from "react";

export default function SearchBar({ 
  search, 
  setSearch, 
  valueRange, 
  setValueRange, 
  valueRanges,
  placeholder = "Search...",
  style = {}
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="controls" style={style}>
      <div className="searchbar">
        <svg className="searchbar__icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
          viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
          strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          className="searchbar__input"
          placeholder={placeholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        
        {valueRanges && (
          <div className="value-filter" ref={dropdownRef}>
            <label className="value-filter__label">Value:</label>
            <div className="custom-dropdown">
              <button
                className={`custom-dropdown__trigger ${isDropdownOpen ? "custom-dropdown__trigger--active" : ""}`}
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                <span className="custom-dropdown__selected">{valueRanges[valueRange].label}</span>
                <svg className={`custom-dropdown__chevron ${isDropdownOpen ? "custom-dropdown__chevron--open" : ""}`}
                  xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              {isDropdownOpen && (
                <div className="custom-dropdown__menu">
                  {valueRanges.map((r, i) => (
                    <div
                      key={i}
                      className={`custom-dropdown__item ${valueRange === i ? "custom-dropdown__item--selected" : ""}`}
                      onClick={() => { setValueRange(i); setIsDropdownOpen(false); }}
                    >
                      {r.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
